import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "@/context/user";
import { Organization } from "@/types/entities";
import storage from "@/utils/storage";
import { isDefined } from "@/utils/validations";
import api from "@/config/api";

const useQueryOrganization = () => {
    const authenticated = useUser(state => state.authenticated);
    const oid = storage.getItem("oid");
    const enabled = authenticated && isDefined(oid);

    const getOrganization = async () => {
        try {
            const data = await api.get<Organization>(`/organizations/${oid}`);
            return data;
        } catch (e) {
            log.error(e, "getOrganization");
        }
    };

    return useQuery({
        queryKey: ["organization", oid],
        queryFn: getOrganization,
        enabled,
    });
};

export default useQueryOrganization;
